module.exports = __webpack_public_path__ + "img/icon_only.1b49c44f.png";